import { useState } from 'react';

function useChangePhone() {
  const [loading, setLoading] = useState(false);
  const [phoneChanged, setPhoneChanged] = useState(false);
  const [needsReauthentication] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  async function changePhone() {
    if (phoneNumber === '') return;

    setLoading(true);
    try {
      setPhoneChanged(true);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  }

  return {
    loading,
    phoneNumber,
    setPhoneNumber,
    phoneChanged,
    changePhone,
    needsReauthentication
  };
}

export default useChangePhone;
